function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderPointer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: props.fill,
    strokeDasharray: "2 2",
    d: "M2 8.5h16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.083 12.04L21.625 8.5l-3.542-3.542v7.083z",
    fill: props.fill
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 8.5,
    r: 2.5,
    fill: props.fill
  }));
}
export default SvgHeaderPointer;